import { render } from "./masterData.vue?vue&type=template&id=dd086e70"
import script from "./masterData.vue?vue&type=script&lang=js"
export * from "./masterData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__